const ShopTheLook = {
  parts: [
    'container',
    'productGrid',
    'productCard',
    'mainProductCard',
    'secondaryProductCard',
    'imageContainer',
    'productImage',
    'shopOverlay'
  ],

  baseStyle: {
    container: {
      py: {base: 5, lg: 20}, // 80px padding from Figma
      px: {base: 5, lg: 0},
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5, // 10px gap
      alignSelf: 'stretch',
    },

    productGrid: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: {base: 5, md: 10}, // 19px gap on mobile, 40px on desktop
      flexDirection: 'row', // Horizontal layout on all screen sizes
      justifyContent: 'center',
      width: 'full',
      maxWidth: '1060px', // 620px + 400px + 40px gap
    },

    productCard: {
      position: 'relative',
      overflow: 'hidden',
    },

    mainProductCard: {
      width: {base: 'calc(50% - 10px)', md: 'calc(58.49% - 40px)'},
      flexShrink: 0,
    },

    secondaryProductCard: {
      width: {base: 'calc(50% - 10px)', md: 'calc(41.51%)'},
      flexShrink: 0,
    },

    imageContainer: {
      position: 'relative',
      width: 'full',
    },

    productImage: {
      width: 'full',
      objectFit: 'cover',
      objectPosition: 'center',
    },

    shopOverlay: {
      display: 'flex',
      width: 'full',
      p: {base: 3, md: 5}, // 12px on mobile, 20px on desktop
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      gap: 1, // 4px
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.40) 100%)',
      position: 'absolute',
      left: 0,
      bottom: 0,
      right: 0,
      height: {base: '68px', md: '84px'},
    },
  },

  variants: {
    default: {},
    half: {
      mainProductCard: {
        width: {base: 'calc(50% - 10px)', md: 'calc(50% - 20px)'},
      },

      secondaryProductCard: {
        width: {base: 'calc(50% - 10px)', md: 'calc(50% - 20px)'},
      },
    },
    full: {
      container: {
        maxWidth: '1440px',
        mx: 'auto',
        py: {base: 5, lg: 20},
        px: {base: 5, lg: 20},
      },
      productGrid: {
        maxWidth: 'none',
        flexDirection: {base: 'column', md: 'row'},
      },
      mainProductCard: {
        width: {base: '100%', md: 'calc(65.62% - 20px)'},
      },

      secondaryProductCard: {
        width: {base: '100%', md: 'calc(34.38% - 20px)'},
      },
    },
  },
};

export default ShopTheLook;
